import Pusher from 'pusher-js';

const PUSHER_KEY     = import.meta.env.VITE_PUSHER_KEY     ?? '';
const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER ?? 'us2';
const API_URL        = import.meta.env.VITE_API_URL        ?? 'http://localhost:4000/api/v2';

// Singleton — se reutiliza en toda la app
let _instance: Pusher | null = null;

/**
 * ⛔ EL TOKEN SE LEE EN CADA AUTORIZACIÓN, NO AL CREAR LA CONEXIÓN. (24/09/2026)
 *
 * pusher-js 8 arma el autorizador de canales privados UNA vez, con los headers del
 * momento. Antes se "actualizaba" pisando `config.auth`, que la librería ya no mira:
 * pasada la primera renovación de sesión (el access token dura una hora), cada canal
 * privado que se abría —el monitor de Gustavo, el wallboard— salía con el token vencido,
 * el back lo rechazaba y la pantalla quedaba "Sin conexión" y sin eventos hasta recargar.
 * `headersProvider` se llama en cada autorización, así que siempre va el token vigente.
 */
let tokenVigente = '';

export function getPusher(accessToken: string): Pusher {
  tokenVigente = accessToken;
  if (_instance) return _instance;

  _instance = new Pusher(PUSHER_KEY, {
    cluster: PUSHER_CLUSTER,
    forceTLS: true,
    channelAuthorization: {
      endpoint: `${API_URL}/chat/pusher/auth`,
      transport: 'ajax',
      headersProvider: () => ({ Authorization: `Bearer ${tokenVigente}` }),
    },
  });

  return _instance;
}

export function destroyPusher() {
  _instance?.disconnect();
  _instance = null;
}
